module.exports = __webpack_public_path__ + "static/media/mountain_biking_1366.f6a88de5.jpg";